import React from 'react';
import LegalLayout from './LegalLayout';

function PrivacyPolicy() {
  return (
    <LegalLayout title="Privacy Policy" updated="August 2026">
      <p className="legal-disclaimer">
        This is a general-purpose privacy notice describing how Orca Transports Ltd
        ("we", "us", "our") handles personal data submitted through this website. It is
        a starting template, not legal advice — we recommend having it reviewed by a
        qualified solicitor before relying on it, and filling in your company
        registration number and any ICO registration details below.
      </p>

      <h2>1. Who we are</h2>
      <p>Orca Transports Ltd, Victory House, Chobham Street, Luton, LU3 3JS, United Kingdom.</p>

      <h2>2. What information we collect</h2>
      <p>When you request a quote or submit a business enquiry through this site, we collect:</p>
      <ul>
        <li>Your name or company name</li>
        <li>Email address</li>
        <li>Phone number</li>
        <li>Collection and delivery postcodes, dates, and load details you provide</li>
        <li>Any message you include in the business enquiry form</li>
      </ul>

      <h2>3. How we use your information</h2>
      <p>We use the information you submit to:</p>
      <ul>
        <li>Verify your email address with a one-time passcode before processing your request</li>
        <li>Calculate and send you a transport quote</li>
        <li>Respond to business account enquiries</li>
        <li>Contact you about the booking or enquiry you submitted</li>
      </ul>
      <p>We do not sell your personal data, and we do not use it for marketing unless you separately ask us to.</p>

      <h2>4. Third parties who process data on our behalf</h2>
      <p>
        We use a third-party email delivery service (Brevo) to send verification codes,
        quotes, and enquiry confirmations, and Google's Distance Matrix API to calculate
        route mileage from the postcodes you provide. These providers process data only
        to the extent needed to deliver these features.
      </p>

      <h2>5. How long we keep your data</h2>
      <p>
        Quote and enquiry details are retained for as long as reasonably needed to
        respond to your request and for our business records, after which they are
        deleted or anonymised.
      </p>

      <h2>6. Your rights</h2>
      <p>Under UK GDPR, you have the right to:</p>
      <ul>
        <li>Ask what personal data we hold about you</li>
        <li>Ask us to correct inaccurate data</li>
        <li>Ask us to delete your data</li>
        <li>Object to how we use your data</li>
      </ul>
      <p>To exercise any of these rights, contact us using the details below.</p>

      <h2>7. Cookies and analytics</h2>
      <p>
        This site does not set any analytics cookies until you accept them via the cookie
        banner shown on your first visit. If you accept, we use Google Analytics (GA4) to
        understand how visitors use the site — for example, which pages are viewed and
        whether a quote request is completed. You can withdraw consent at any time by
        clearing your browser's local storage for this site, which will show the banner
        again on your next visit.
      </p>

      <h2>8. Contact us</h2>
      <p>
        Email: <a href="mailto:sales@orcatransports.com">sales@orcatransports.com</a><br />
        Phone: <a href="tel:+447501046288">+44 7501 046288</a>
      </p>
    </LegalLayout>
  );
}

export default PrivacyPolicy;
